const EMAIL = "getbemnet21@gmail.com";

function SideEmail() {
  return (
    <div className="fixed left-0 top-1/2 -translate-y-1/2 z-30 hidden lg:flex w-36 items-center justify-start pl-4">
      <a
        href={`mailto:${EMAIL}`}
        className="block -rotate-90 origin-left text-xs tracking-[0.2em] text-zinc-500 hover:text-zinc-200 transition-colors whitespace-nowrap select-none"
        aria-label={`Email ${EMAIL}`}
      >
        {EMAIL}
      </a>
    </div>
  );
}

export default SideEmail;
